import { getSortFromSearchParams } from '@/common/utils/pathHelper';
import { useSearchParams } from 'next/navigation';
import { useCallback, useMemo, useState } from 'react';

const defaultSort = {
  sortId: 'sortItem.created_at',
  sortText: 'New Arrivals',
  sortAttribute: 'created_at',
  sortDirection: 'DESC',
  sortQuery: 'new',
  // sortId: "sortItem.position",
  // sortText: "Featured",
  // sortAttribute: "position",
  // sortDirection: "ASC",
  // sortQuery: "featured",
};

export const useSort = () => {
  const searchParams = useSearchParams(defaultSort);

  const [sortState, setSortState] = useState(getSortFromSearchParams(searchParams));
  const setSort = useCallback(value => {
    // do nothing
  }, []);

  const sortApi = useMemo(
    () => ({
      setSort,
    }),
    [setSort],
  );

  return [sortState, sortApi];
};
